import { Switch } from "antd";

import { BaseSwitchProps } from "./types";

const BaseSwitch = ({ ...props }: BaseSwitchProps) => {
  return <Switch {...props} />;
};

export default BaseSwitch;
